import {Component, input, model} from '@angular/core';
import {IconsComponent} from '../icons/icons.component';

@Component({
  selector: 'app-bottom-drawer',
  imports: [
    IconsComponent
  ],
  templateUrl: './bottom-drawer.component.html',
  styleUrl: './bottom-drawer.component.css'
})
export class BottomDrawerComponent {
  isOpen = model.required<boolean>();
  maxHeight = input<string>('max-h-[80vh]');

  onBackdropClick() {
    this.close();
  }

  toggleDrawer() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen.set(true);
  }

  close() {
    this.isOpen.set(false);
  }
}
